import { render, staticRenderFns } from "./platformRecords.vue?vue&type=template&id=33abc3e8&scoped=true"
import script from "./platformRecords.vue?vue&type=script&lang=js"
export * from "./platformRecords.vue?vue&type=script&lang=js"
import style0 from "./platformRecords.vue?vue&type=style&index=0&id=33abc3e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33abc3e8",
  null
  
)

export default component.exports